module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-y",
    attrs: {
      "id": "analytics"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "spinner"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x",
    staticStyle: {
      "font-size": "40px",
      "color": "#228D7A"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "spinnerBackground"
  }), _vm._v(" "), _c('div', {
    staticClass: "controlPanel"
  }, [_c('div', {
    staticClass: "selectSensor"
  }, [_c('v-form', {
    ref: "form",
    staticClass: "sensorForm",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Vyberte senzor",
      "value": _vm.selectedSensor,
      "items": _vm.sensors
    },
    on: {
      "change": _vm.selectSensor
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "selectDate"
  }, [_c('p', {
    staticClass: "caption annot"
  }, [_vm._v(_vm._s(_vm.$t('controlPanel.selectDate')))]), _vm._v(" "), _c('input', {
    staticClass: "datepicker",
    attrs: {
      "type": "text",
      "name": "daterange"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('v-layout', {
    staticClass: "blue lighten-2 stats",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "headline"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('statsDashboard.currentValues')) + "\n          "), _c('span', {
    staticClass: "subheading"
  }, [_vm._v("(" + _vm._s(_vm.$t('statsDashboard.lastUpdate')) + " " + _vm._s(_vm.dailyValues.time) + ")")])]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-1 card"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "subheading"
  }, [_c('v-icon', {
    staticClass: "currentValueIcon",
    attrs: {
      "color": "red"
    }
  }, [_vm._v("fa-thermometer-full")]), _vm._v("\n                " + _vm._s(_vm.$t('statsDashboard.temperature')) + "\n              ")], 1), _vm._v(" "), _c('h4', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.dailyValues.temp) + " °C")])])])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-1 card"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "subheading"
  }, [_c('v-icon', {
    staticClass: "currentValueIcon",
    attrs: {
      "color": "blue darken-3"
    }
  }, [_vm._v("fa-tint")]), _vm._v("\n                " + _vm._s(_vm.$t('statsDashboard.moisture')) + "\n              ")], 1), _vm._v(" "), _c('h4', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.dailyValues.moist) + " %")])])])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-1 card"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "subheading"
  }, [_c('v-icon', {
    staticClass: "currentValueIcon",
    attrs: {
      "color": "orange darken-3"
    }
  }, [_vm._v("fa-dashboard")]), _vm._v("\n                " + _vm._s(_vm.$t('statsDashboard.pressure')) + "\n              ")], 1), _vm._v(" "), _c('h4', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.dailyValues.press) + " hPa")])])])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-1 card"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "subheading"
  }, [_c('v-icon', {
    staticClass: "currentValueIcon",
    attrs: {
      "color": "indigo"
    }
  }, [_vm._v("fa-cloud")]), _vm._v("\n                " + _vm._s(_vm.$t('statsDashboard.precipitation')) + "\n              ")], 1), _vm._v(" "), _c('h4', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.dailyValues.prec) + " mm/m2/h")])])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "grey lighten-4 stats",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.dailyStatistics')))]), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-1 card"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "subheading"
  }, [_c('v-icon', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("fa-thermometer-full")])], 1), _vm._v(" "), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.maxT')))]), _vm._v(" "), _c('h4', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.dailyStats.maxTemp) + " °C")])])])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-1 card"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "subheading"
  }, [_c('v-icon', {
    attrs: {
      "color": "indigo"
    }
  }, [_vm._v("fa-thermometer-empty")])], 1), _vm._v(" "), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t('statsDashboard.minT')))]), _vm._v(" "), _c('h4', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.dailyStats.minTemp) + " °C")])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "windchart"
    }
  })], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chartArea"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartdiv"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56cb15db","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Analytics.vue
// module id = 193
// module chunks = 1